export const multiplyWithDecimals = (value1, value2) => Number((value1 * value2).toFixed(2))

export const operationWithDecimals = (value1, value2, isSum = true) => {
  if (isSum) return sumWithDecimals(value1, value2)

  return Number((value1 - value2).toFixed(2))
}

export const sumWithDecimals = (value1, value2) => Number((value1 + value2).toFixed(2))
